import axios from "./axiosInstance";

const TestimonialAPI = {
  getDetails: (params) => axios.get("testimonials/", {params}),

  addDetails: (payload) => axios.post("testimonials/", payload),

  updateDetails: (id, payload) => axios.put(`testimonials/${id}`, payload),

  getSingleDetails: (id) => axios.get(`testimonials/${id}`),

  updateStatus: (id) => axios.patch(`testimonials/${id}/status`),

  updateOrder: (payload) => axios.put("testimonials/reorder", payload),

  deleteItem: (id) => axios.delete(`testimonials/${id}`),
};

export default TestimonialAPI;
